export enum WIDGET_ARTICLE_LIST {
    /**
     * @value Article actions
     */
    ARTICLE_ACTIONS = 'WIDGET_ARTICLE_LIST.ARTICLE_ACTIONS',
    /**
     * @value Article list settings
     */
    ARTICLE_LIST_WIDGET_SETTINGS_TITLE = 'WIDGET_ARTICLE_LIST.ARTICLE_LIST_WIDGET_SETTINGS_TITLE',
    /**
     * @value Copy article link
     */
    COPY_ARTICLE_LINK = 'WIDGET_ARTICLE_LIST.COPY_ARTICLE_LINK',
    /**
     * @value Create an article
     */
    CREATE_ARTICLE = 'WIDGET_ARTICLE_LIST.CREATE_ARTICLE',
    /**
     * @value Display article
     */
    DISPLAY_ARTICLE = 'WIDGET_ARTICLE_LIST.DISPLAY_ARTICLE',
    /**
     * @value This section gives you access to articles
     */
    EMPTY_STATE_DESCRIPTION = 'WIDGET_ARTICLE_LIST.EMPTY_STATE_DESCRIPTION',
    /**
     * @value No articles match your search. Please try another entry.
     */
    EMPTY_STATE_SEARCH = 'WIDGET_ARTICLE_LIST.EMPTY_STATE_SEARCH',
    /**
     * @value There are no articles yet
     */
    EMPTY_STATE_TITLE = 'WIDGET_ARTICLE_LIST.EMPTY_STATE_TITLE',
    /**
     * @value Search for an article
     */
    SEARCH_BY_TEXT = 'WIDGET_ARTICLE_LIST.SEARCH_BY_TEXT',
    /**
     * @value Only display articles from communities the user is following.
     * @description The helper displayed after the "Followed communities only" filter to explain what the filter does in the article list widget settings.
     *
     */
    SETTINGS_FOLLOWED_COMMUNITIES_FILTER_HELPER = 'WIDGET_ARTICLE_LIST.SETTINGS_FOLLOWED_COMMUNITIES_FILTER_HELPER',
    /**
     * @value Load more button allows users to display more articles.
     * @description Text used to describe the load more option in widget settings of the widget article list
     */
    SETTINGS_SHOW_LOAD_MORE_HELPER = 'WIDGET_ARTICLE_LIST.SETTINGS_SHOW_LOAD_MORE_HELPER',
}
